module.exports = __webpack_public_path__ + "static/media/timer.0d26b3e1.png";